require("./pride.css")

exports.pride = () => {
  document.querySelector("header").classList.toggle("pride")
}
